export function scaleFactor() {
  return window.devicePixelRatio || 1;
}
